import script from "./WCCouponRowModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCCouponRowModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCCouponRowModern.vue?vue&type=style&index=0&id=76f70567&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f70567"]])

export default __exports__